import { SHOW_REVIEWS } from "@/config/features";

const partnersBase = [
  { name: "COFRAC", icon: "ri-award-fill", color: "text-[#0F3B5F]", desc: "Accréditation officielle" },
  { name: "Bureau Veritas", icon: "ri-verified-badge-fill", color: "text-[#0F3B5F]", desc: "Partenaire certifié" },
  { name: "RC Pro", icon: "ri-shield-check-fill", color: "text-[#16A34A]", desc: "Assurance professionnelle" },
  { name: "Ministère du Logement", icon: "ri-government-fill", color: "text-[#0F3B5F]", desc: "Agréé par l'État" },
];
const partnersWithReviews = [
  ...partnersBase,
  { name: "Google ★ 4.9", icon: "ri-star-fill", color: "text-[#F59E0B]", desc: "127 avis vérifiés" },
];
const partners = SHOW_REVIEWS ? partnersWithReviews : partnersBase;

export default function TrustBar() {
  return (
    <section className="bg-white border-y border-gray-100 py-10">
      <div className="max-w-6xl mx-auto px-6">
        <p className="text-center text-xs font-semibold text-gray-400 uppercase tracking-widest mb-8">
          Certifications &amp; Partenaires
        </p>
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
          {partners.map((p) => (
            <div key={p.name} className="flex flex-col items-center gap-2 group cursor-default">
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl bg-gray-50 group-hover:bg-gray-100 transition-colors`}>
                <i className={`${p.icon} ${p.color} text-2xl`}></i>
              </div>
              <div className="text-center">
                <div className="text-sm font-bold text-[#0F3B5F]">{p.name}</div>
                <div className="text-xs text-gray-400">{p.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
